import React from "react"
import { FlatButton } from "material-ui"
import strings from "../../localization/strings"
import AppStateStore from "../../stores/AppStateStore"
interface IProps {
    pendingReviewed: boolean
    handleGenerateTimecard(): void
}

const PendingTimecardUI: React.SFC<IProps> = (props: IProps) => {
    return (
        <div style={{ display: "inline-block", width: "100%", height: 175, textAlign: "center", borderTop: "solid 1px rgb(224, 224, 224)" }}>
            <FlatButton
                data-intercom-target={"menu-Employees-Timecards-Btn-GenerateTimeCard"}
                label={strings.Generate_Timecard}
                backgroundColor={AppStateStore.getFrontEndSettings().UISettings.AccentColor }
                hoverColor={AppStateStore.getFrontEndSettings().UISettings.AccentColor }
                style={{ marginTop: 75 }}
                labelStyle={{ color: "white" }}
                onClick={() => {
                    AppStateStore.setTextProgressSnackbarContent({ progressText: strings.Generating_timecard_please_wait })
                    props.handleGenerateTimecard()
                }}
            />
            {props.pendingReviewed &&
                <div style={{ marginTop: 10, fontSize: 14, lineHeight: "25px" }}>
                    {strings.There_has_been_changes_made_to_the_punches_in_this_timecard_that_require_it_to_be_regenerated}
                    <br />
                    {strings.Click_the_Generate_timecard_above_to_view_the_timecard}
                </div>
            }
        </div>
    )
}

export default PendingTimecardUI